import { createStore } from "@stencil/store";
import { Environment, getEnvironment } from "../entities/environment";
import {
  DEFAULT_ENVIRONMENT,
  DEFAULT_LOCALE,
  DEFAULT_UNREAD_MESSAGES_COUNT,
  LOGGED_OUT_USER_STATUS,
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "../utility/constants";
import { Application, ApplicationType } from "../utility/constants/app";
import { NavigateAuthOptions } from "../entities/navigate-auth";

export type ConsentService = "googleMaps" | "newRelic";
export const consentServiceMap = {
  googleMaps: "Google Maps",
  newRelic: "New Relic",
};

export const allConsentsAcceptedState = {
  googleMaps: true,
  newRelic: true,
};

export interface NavStateType {
  pageName?: string;
  loggedInState: string;
  unreadMessagesCount: number;
  userConsent: { [key in ConsentService]: boolean };
  env: Environment;
  app: ApplicationType;
  usingKeyboard: boolean;
  locale: string;
  theme: NavigationThemeType;
  mode: NavigationModeType;
  initialRoutingPath?: string;
  modelType?: string;
  preloadedSeriesImages?: Record<string, boolean>;
  accountLoaded?: boolean;
  dealerSeachLoaded?: boolean;
  authOptions?: Partial<NavigateAuthOptions>;
  hideShowOnScroll?: boolean;
  hasCountrySelector?: boolean;
}

export const navStateDefaultData = {
  loggedInState: LOGGED_OUT_USER_STATUS,
  unreadMessagesCount: DEFAULT_UNREAD_MESSAGES_COUNT,
  userConsent: {
    googleMaps: false,
    newRelic: false,
  },
  env: getEnvironment(DEFAULT_ENVIRONMENT),
  app: Application.default,
  usingKeyboard: false,
  locale: DEFAULT_LOCALE,
  theme: NavigationTheme.light,
  mode: NavigationMode.navbar,
  hasCountrySelector: false
};

export const navStateStore = createStore<NavStateType>(navStateDefaultData);
